import { trackEvent } from '@fs/zion-analytics'
import handleReducerSimpleSetter from '../../../helpers/handleReducerSimpleSetter'
import getReducerHandler from '../../../helpers/getReducerHandler'

const ACTIONS = Object.freeze({
  INIT_PersonViewer: 'INIT_PersonViewer',
  SET_LOCK_MEMORIES: 'SET_LOCK_MEMORIES',
  SET_TAB_CONTENT_OVERFLOW: 'SET_TAB_CONTENT_OVERFLOW',
  STATE_UPDATE: 'STATE_UPDATE',
})

const PersonViewerInitialState = { isLoading: true, tabContentOverflow: 'auto', lockMemories: false }

/*
 * --- INDIVIDUAL ACTION HANDLERS ---
 * (Set multiple values & merge/processing logic only, otherwise use handleReducerSimpleSetter)
 */

const handleInitPersonViewer = (state, action) => {
  trackEvent({ event_name: action.type })
  return { ...state, ...action.data, isLoading: false }
}

// --- Handlers registry ---
const handlers = {
  [ACTIONS.INIT_PersonViewer]: handleInitPersonViewer,
  [ACTIONS.SET_LOCK_MEMORIES]: handleReducerSimpleSetter,
  [ACTIONS.SET_TAB_CONTENT_OVERFLOW]: handleReducerSimpleSetter,
  [ACTIONS.STATE_UPDATE]: handleReducerSimpleSetter,
}

const PersonViewerReducer = (state, action) => getReducerHandler(state, action, handlers)

export { PersonViewerInitialState, PersonViewerReducer, ACTIONS }
